import type { FC } from "react";
import type { RegisterOptions } from "react-hook-form";
import { Controller } from "react-hook-form";

import { TextArea } from "@ui/components/Inputs";
import { useTranslations } from "@ui/providers/useTranslations";

export type FormTextAreaProps = {
  id: string;
  label: string;
  placeholder?: string;
  disclaimer?: string;
  validationRules: RegisterOptions;
  dataTestId?: string;
};

export const FormTextArea: FC<FormTextAreaProps> = ({
  id,
  label,
  placeholder,
  disclaimer,
  validationRules,
  dataTestId = "formTextArea",
}) => {
  const { __ } = useTranslations();

  return (
    <Controller
      name={id}
      defaultValue=""
      rules={validationRules}
      render={({ field, fieldState: { error } }) => (
        <TextArea
          {...field}
          id={id}
          label={label}
          placeholder={placeholder}
          isError={!!error}
          errorText={error?.message}
          helperText={disclaimer}
          required={!!validationRules.required}
          necessityIndicator
          optionalText={__("form_fields.optional")}
          data-testid={dataTestId}
        />
      )}
    />
  );
};
